import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Contract } from "@/types/contract";

interface BuyerInfoProps {
  contract: Contract;
}

export function BuyerInfo({ contract }: BuyerInfoProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Buyer Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <span className="font-medium">Buyer Name:</span>
          <p>
            {[
              (contract as any).buyer_first_name,
              (contract as any).buyer_middle_name,
              (contract as any).buyer_last_name
            ].filter(Boolean).join(' ') || 'N/A'}
          </p>
        </div>
        
        {(contract as any).buyer_address && (
          <div>
            <span className="font-medium">Buyer Address:</span>
            <p className="whitespace-pre-line">{(contract as any).buyer_address}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}